import {ENDPOINTS} from 'constants/endpoints';
import {AMAZON_BUTTON_ID_V2, AMAZON_URL_PARAM} from 'desktop/pages/checkout/constants/amazon';
import {apiConfig} from 'libs/api/api';

type AmazonButtonType = {
    sellerId: string;
    color: string;
    isSandbox: boolean;
    total: number;
    handleSendAnalytics: () => void;
};

/**
 * Listener for amazon v2 button
 * @param {number} total - total quote amount
 * @param {function} handleSendAnalytics - analytics callback
 */
export const createCheckoutSessionAmazon = async (
    total: number,
    handleSendAnalytics: () => void,
) => {
    const {
        data: {checkoutSessionId},
    } = await apiConfig.instanceGusaBackend({
        baseURL: apiConfig.API_URL,
        data: {
            checkoutCancelUrl: `${window.location.origin}/checkout/cart`,
            checkoutResultReturnUrl: `${window.location.origin}/checkout/onepage/?${AMAZON_URL_PARAM.PAYMENT_CONFIRMED}=true`,
            checkoutReviewReturnUrl: `${window.location.origin}/checkout/onepage/?${AMAZON_URL_PARAM.PAYMENT_CONFIRMED}=false`,
            payment: {
                amount: total,
            },
        },
        method: 'post',
        url: ENDPOINTS.AMAZON_SESSION,
    });

    handleSendAnalytics();

    return checkoutSessionId;
};

/**
 * Button amazon
 * @param {AmazonButtonType} button - Params for amazon button
 */
export const amazonButtonV2 = ({
    color,
    handleSendAnalytics,
    isSandbox,
    sellerId,
    total,
}: AmazonButtonType) => {
    window.amazon.Pay?.renderButton(`#${AMAZON_BUTTON_ID_V2}`, {
        buttonColor: color,
        checkoutLanguage: 'en_US',
        createCheckoutSession: () => createCheckoutSessionAmazon(total, handleSendAnalytics),
        estimatedOrderAmount: {amount: String(total), currencyCode: 'USD'},
        ledgerCurrency: 'USD',
        merchantId: String(sellerId),
        placement: 'Product',
        productType: 'PayAndShip',
        sandbox: Boolean(isSandbox),
    });
};
